import React, { createElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import escape from 'lodash/escape';
import { universalActiveHtml } from '../../../utils/index';

import './Header.module.css';

const defaultWeights = {
  1: 700,
  2: 600,
  3: 400,
  4: 700,
  5: 400,
  6: 400
};

const Header = ({ children, classes, displayAs, styles, level, weight }) => {
  const html = {
    __html: escape(children).replace('\r\n', '<br/>')
  };

  // workaround for issue https://github.com/gajus/babel-plugin-react-css-modules/issues/181
  const CreateElement = ({ element, children, ...props }) =>
    createElement(element, props, children);

  return (
    <CreateElement
      element={`h${level}`}
      className={classes}
      styleName={classNames(
        'headertext',
        `as-h${displayAs}`,
        `weight-${weight ? weight : defaultWeights[level]}`
      )}
      style={styles}
    >
      {universalActiveHtml(html.__html, {})}
    </CreateElement>
  );
};

Header.propTypes = {
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).isRequired,
  displayAs: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).isRequired,
  weight: PropTypes.node,
  children: PropTypes.node,
  styles: PropTypes.object
};

export default Header;
